module.exports = __webpack_public_path__ + "img/Malaysia-2.519b7278.jpg";